export interface IconProps {
    classNames?: string;
    /** Text alternative for an icon that carries meaning on its own. Omit it for decorative icons, which are hidden from assistive technology. */
    label?: string;
}

export const iconA11yProps = (label?: string) => (label ? ({ role: 'img', 'aria-label': label } as const) : ({ 'aria-hidden': true } as const));
